import { useCallback, useEffect, useRef, useState } from "react";
import type { UpgradePrices } from "@frontier/protocol/upgrade-prices";
import { api } from "./session-api";

export interface UpgradePricing {
  prices: UpgradePrices | null;
  error: string | null;
  reload: () => Promise<UpgradePrices | null>;
}
export function useUpgradePrices(): UpgradePricing {
  const [prices, setPrices] = useState<UpgradePrices | null>(null);
  const [error, setError] = useState<string | null>(null);
  const pending = useRef<AbortController | null>(null);
  const reload = useCallback(async () => {
    pending.current?.abort();
    const controller = new AbortController();
    pending.current = controller;
    setPrices(null);
    setError(null);
    try {
      const result = await api.upgradePrices(controller.signal);
      if (controller.signal.aborted || pending.current !== controller)
        return null;
      setPrices(result);
      return result;
    } catch (failure) {
      if (!controller.signal.aborted && pending.current === controller) {
        console.warn("upgrade-prices-load-failed", {
          message:
            failure instanceof Error ? failure.message : "Price request failed",
        });
        setError("Не удалось загрузить стоимость улучшений.");
      }
      return null;
    }
  }, []);
  useEffect(() => {
    void reload();
    return () => pending.current?.abort();
  }, [reload]);
  return { prices, error, reload };
}
